// extracted by mini-css-extract-plugin
module.exports = {"action":"action__1_ipx","icon":"icon__1TQPE","action-warning":"action-warning__23OfA"};